var customStyleContent = `.kuSearchResultsPageContainer *{letter-spacing:.06em;color:#93705a!important;font-family:HelvCondensed,sans-serif!important}.klevuTarget.klevu-fluid>div{width:100%;max-width:unset;right:0!important;position:absolute;background-color:#f8f8f8;left:0!important}.kuEmptySearchBox .kuSearchPersonalizationsContainer{width:100%}#klevuSearchingArea [ku-container][data-container-role=main]{width:100%;padding:0 60px 40px;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}#klevuSearchingArea [ku-container][data-container-role=header]{width:25%;display:inline-block;vertical-align:top}#klevuSearchingArea [ku-container][data-container-role=content]{width:75%;display:inline-block;vertical-align:top}.klevuAutoSuggestionsWrap,.klevuAutoSuggestionsWrap ul li a,.klevuResultsBlock .klevuProductsViewAll a,.klevuResultsBlock .klevuQuickSearchResults .klevuProductItemBottom,.klevuResultsBlock .klevuQuickSearchResults .klevuProductItemTop,.klevuResultsBlock .klevuQuickSearchResults ul li a.klevuQuickProductInnerBlock,.klevuResultsBlock .klevuSuggestionHeading,.klevuSuggestionHeading,.kuPopularSearchTerms li a,.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular .klevuPopularProductItemBottom,.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular .klevuPopularProductItemTop{padding:0}.klevuAutoSuggestionsWrap{padding-bottom:20px;border:0}.klevuSuggestionHeading{overflow:visible;padding:4px!important;margin-top:8px;margin-bottom:5px;text-align:left;font-family:"Quicksand,sans-serif;"!important;font-size:16px;text-transform:uppercase;position:relative}.klevuAutoSuggestionsWrap ul li a{display:block;padding:6px 10px 6px 10px;line-height:14px;color:#000;text-decoration:none;font-size:13px;text-transform:capitalize}.klevuResultsBlock .klevuProductsViewAll a{margin-right:10px;color:#222;text-decoration:none;font-size:12px;font-family:"VQuicksand,sans-serif;";border:0;font-weight:600}.klevuHeadingText{color:#222;display:inline-block;padding:0 4px;font-size:12px}.klevuResultsBlock .klevuProductsViewAll{top:5px}.klevuResultsBlock .klevuQuickSearchResults ul:before{content:unset}.klevuResultsBlock .klevuQuickSearchResults ul{display:-webkit-box;display:-ms-flexbox;display:flex}.klevuResultsBlock .klevuQuickSearchResults ul li a.klevuQuickProductInnerBlock{text-decoration:none;color:#000;outline:0;display:block;padding:6px 10px 10px 10px;height:auto;line-height:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.klevuResultsBlock .klevuQuickSearchResults ul li{border:0;display:inline-block;width:calc(100% * 1/5)!important;height:auto;text-align:left;position:relative;margin:0;vertical-align:top}.klevuResultsBlock .klevuQuickSearchResults img{width:100%}.klevuResultsBlock .klevuQuickSearchResults ul li:hover{background-color:#fff}.klevuResultsBlock .klevuQuickSearchResults ul li a:hover{opacity:.75}.klevuResultsBlock .klevuQuickSearchResults .klevuProductItemTop{width:100%}.klevuResultsBlock .klevuQuickSearchResults .klevuQuickImgWrap{height:auto!important}.klevuResultsBlock .klevuQuickSearchResults img{margin-top:5px}.klevuResultsBlock .klevuQuickSearchResults ul li .klevuQuickProductName{font-size:14px;text-decoration:none;color:#222;word-wrap:break-word;text-transform:capitalize;margin:8px 0 0 0}.klevuResultsBlock .klevuQuickSearchResults .klevuProductItemBottom .klevu-desc-l2{color:#222;font-size:12px;line-height:1.2;margin:5px 0 8px 0;font-family:"Quicksand,sans-serif;";-webkit-line-clamp:2!important}.klevuResultsBlock .klevuQuickSearchResults ul li .klevuQuickSalePrice{font-weight:700;font-size:12px;margin-bottom:5px;color:#222;font-family:"Quicksand,sans-serif;"}.klevuResultsBlock .klevuQuickSearchResults .klevuProductItemBottom{width:100%}.kuQuickSearchNoRecordFound{background-color:#f8f8f8;margin:0}.klevuHeadingText{font-weight:600}.kuQuickSearchNoRecordFound .kuDividerLine{border:0;margin:0}.kuQuickSearchNoRecordFound .kuQuickNoResultsMessage{font-size:14px;padding:15px 20px;text-align:center;font-family:"Quicksand,sans-serif;";color:#222}.kuQuickSearchNoRecordFound .kuQuickNoResults{max-width:100%}.kuEmptySearchBox #klevuSearchingArea [ku-container][data-container-role=content]{width:100%}.kuEmptySearchBox.klevuTarget.kuQuickSearchResultsContainer.kuPersonalizedSearchRecsEnabled>div{max-width:100%!important;left:0!important}.kuPersonalizedSearchRecsEnabled.kuEmptySearchBox [ku-container][data-container-role=content]{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}#klevuCategoryArea ul li{display:none}#klevuCategoryArea ul li:nth-child(-n+3){display:block}.kuCarousel .kuSlide{width:calc(100% * 1/5)!important;margin-bottom:5px}.kuCarousel .kuCarousel-content{display:-webkit-box;display:-ms-flexbox;display:flex}.kuEmptySearchBox.klevuTarget.kuQuickSearchResultsContainer.kuPersonalizedSearchRecsEnabled [ku-container][data-container-role=left]{width:24%;padding:0;margin-right:1%}.kuSearchPersonalizationsContainer [data-container-position=center]{width:76%;display:block}.kuCarousel .kuSlide>a{width:90%!important;max-width:90%;margin:5px 5%;-webkit-box-sizing:border-box!important;box-sizing:border-box!important;padding:0;float:none;display:block;border:0 solid #eee;text-decoration:none}.kuRecommendationSlider .klevuProductItemTop .klevuQuickImgWrap{max-height:unset!important}.kuSearchPersonalizationsContainer .klevuResultsBlock .klevuQuickSearchResults img{margin-top:0}.kuSearchPersonalizationsContainer .klevuQuickProductDescBlock{font-size:12px;text-decoration:none;color:#222;word-wrap:break-word;font-weight:500;line-height:18px;margin-top:5px;margin-bottom:0;text-align:left}.kuEmptySearchBox.klevuTarget.kuPersonalizedSearchRecsEnabled .kuPopularSearchTerms ul,.kuEmptySearchBox.klevuTarget.kuPersonalizedSearchRecsEnabled .kuRecentSearchTerms ul{color:#222;text-align:center;padding-bottom:10px;margin-bottom:15px}.kuEmptySearchBox.klevuTarget.kuPersonalizedSearchRecsEnabled .kuPopularSearchTerms ul li,.kuEmptySearchBox.klevuTarget.kuPersonalizedSearchRecsEnabled .kuRecentSearchTerms ul li{display:block;padding:6px 10px 6px 10px;font-size:13px;line-height:14px;color:#222;text-decoration:none;width:100%;font-family:Visby CF Medium}.kuEmptySearchBox.klevuTarget.kuPersonalizedSearchRecsEnabled .kuRecentSearchTerms ul li a{padding:0}.kuQuickSearchNoRecordFound .klevuPopularProductsHeading{padding:10px;text-align:center;font-family:"Visby CF Extra Bold";font-size:14px;text-transform:uppercase}.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul{display:-webkit-box;display:-ms-flexbox;display:flex;text-align:left;width:100%;max-width:780px;margin:0 auto}.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li{display:inline-block;height:auto;position:relative;text-align:left;width:calc(100% * 1/4);vertical-align:top;border-bottom:0}.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li a.klevuQuickPopularProductInnerBlock{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;color:#000;display:block;height:auto;line-height:20px;outline:medium none;padding:10px 20px;text-decoration:none}.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular .klevuPopularProductItemTop{width:100%}.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular .klevuQuickImgWrap{height:auto!important}.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular .klevuPopularProductItemBottom{width:100%}.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li .klevuQuickOrigPrice,.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li .klevuQuickPopularProductDescBlock{margin-left:0}.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular .klevuPopularProductItemBottom .klevu-desc-l2{display:none!important}.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li .klevuQuickProductName{-webkit-line-clamp:2;font-weight:400;overflow-wrap:break-word;text-decoration:none;font-family:"Visby CF Extra Bold";font-size:13px;text-transform:capitalize;margin:5px 0 3px 0;font-weight:600}.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li .klevuQuickOrigPrice,.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li .klevuQuickSalePrice{color:#393939!important;font-size:11px!important;font-weight:400;margin-bottom:5px}.klevuAutoSuggestionsWrap ul li b{font-weight:600!important}.kuCarousel .nav{top:35%;margin-top:0}.kuCarousel .nav-left{left:10px}.kuCarousel .nav-right{right:10px}@media screen and (max-width:1024px){#klevuSearchingArea [ku-container][data-container-role=main],.kuPersonalizedSearchRecsEnabled.kuEmptySearchBox [ku-container][data-container-role=content]{display:block!important}#klevuSearchingArea [ku-container][data-container-role=header]{width:100%;display:block}.klevuAutoSuggestionsWrap ul li,.klevuSuggestionHeading{text-align:center}.klevuQuickSearchingArea{top:150px!important;max-height:700px;padding:0 20px;overflow-y:scroll;min-height:450px}.klevuResultsBlock .klevuQuickSearchResults ul li{width:calc(100% * 1/3)!important}.klevuResultsBlock .klevuQuickSearchResults ul{-ms-flex-wrap:wrap;flex-wrap:wrap}.kuEmptySearchBox.klevuTarget.kuQuickSearchResultsContainer.kuPersonalizedSearchRecsEnabled [ku-container][data-container-role=left],.kuSearchPersonalizationsContainer [data-container-position=center]{width:100%;display:block}.kuCarousel .kuSlide{width:calc(100% * 1/3)!important}.kuCarousel .kuCarousel-content{overflow-x:hidden;overflow-y:auto}#klevuSearchingArea [ku-container][data-container-role=main]{width:100%;padding:0 20px 0}}@media screen and (max-width:640px){.klevuResultsBlock .klevuQuickSearchResults .klevuProductItemTop{width:100%!important}#klevuSearchingArea [ku-container][data-container-role=content]{width:100%}.klevuResultsBlock .klevuQuickSearchResults ul li{width:100%!important;max-width:300px;margin:10px auto;display:block;background:#fff}.klevuResultsBlock .klevuQuickSearchResults ul li a.klevuQuickProductInnerBlock{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.klevuResultsBlock .klevuQuickSearchResults .klevuProductItemTop{width:calc(35% - 20px)!important;display:inline-block;margin-right:20px;vertical-align:middle}.klevuResultsBlock .klevuQuickSearchResults ul li .klevuQuickProductDescBlock{margin-left:0}.klevuResultsBlock .klevuQuickSearchResults .klevuProductItemBottom{width:65%}.kuEmptySearchBox.klevuTarget.kuQuickSearchResultsContainer.kuPersonalizedSearchRecsEnabled [ku-container][data-container-role=left]{width:100%;margin-right:0}.kuSearchPersonalizationsContainer [data-container-position=center]{width:100%}.kuPersonalizedSearchRecsEnabled.kuEmptySearchBox [ku-container][data-container-role=content]{display:block!important}[ku-container][data-container-role=left]{display:block}.kuCarousel .kuSlide{width:calc(100% * 1/2)!important}.kuEmptySearchBox.klevuTarget.kuPersonalizedSearchRecsEnabled .klevuProductItemTop{width:100%!important}.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li{width:calc(100% * 1/2)}.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul{-ms-flex-wrap:wrap;flex-wrap:wrap}.klevuTarget.klevu-fluid>div{overflow-y:scroll}}.kuContainer{padding:0!important;margin-top:30px}.ku-klevu .page-width h1,.ku-klevu .top-banner,.kuContainer .kuTabs,.kuPagination,.kuSearchResultsPageContainer .kuDropdown.kuDropItemsPerpage{display:none!important}.kuFilters[data-position=top]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:end;padding:0}.kuFilters[data-position=top] .kuFiltersTitleHeading{color:#222!important;display:inline-block;float:left;border:0 solid #414042;font-size:16px;height:32px;padding:0;width:13.5%;text-align:left;min-width:60px;text-transform:uppercase;font-family:"Visby CF Extra Bold";font-weight:600}.kuFilters[data-position=top] .kuFilterBox .kuFilterHead{border-bottom:0 none;border-right:0 solid #e8e8e8;color:#414042;height:32px;line-height:32px;padding:0 10px;position:relative;text-align:center;text-transform:uppercase;font-family:"Visby CF Extra Bold"}.kuFilters[data-position=top] .kuFilterBox .kuFilterHead.kuCollapse::after,.kuFilters[data-position=top] .kuFilterBox .kuFilterHead.kuExpand::after{right:10px;border-color:#93705a;top:10px}.kuSearchResultsPageContainer .kuDropdown{z-index:1;padding-top:12px;margin-top:10px!important}.kuFilters[data-position=top] .kuFilterBox .kuFilterNames{min-height:auto}.kuFilterBox .kuFilterNames ul li a{display:block;position:relative;overflow:hidden;margin:0;padding:0;font-size:13px;text-decoration:none;cursor:pointer;font-style:normal;color:#414042;border:none!important;line-height:24px;font-family:"Visby CF Extra"}.kuFilterBox .kuFilterIcon:before{height:15px;width:15px;margin-top:4px}.kuFilterBox.kuMulticheck .kuFilterNames ul li a:hover span.kuFilterIcon:after,.kuFilterBox.kuMulticheck .kuFilterNames ul li.kuSelected span.kuFilterIcon:after{top:7px;left:3px;border:1px solid #ddd;border-top:0;border-right:0;border-radius:0}.kuFilterTag{background:#eee;border:0 solid #f8f8f8;margin-right:4px;border-radius:0;font-size:11px;padding:0 5px;color:#222!important;margin-bottom:4px;display:inline-block;line-height:20px;text-transform:capitalize;font-family:Visby CF Medium}.kuFilterTagsContainer .kuFilterTagKey,.kuFilterTagsContainer .kuFilterTagValue{padding:0;margin:0}.kuFilterTagsContainer .kuFilterTagKey{color:#222}.kuFilterTagsContainer .kuFilterTagClearAll{border:0}.kuFilterTagValue>span{font-size:14px;display:contents}.kuFilterTagsContainer .kuFilterTagClearAll{padding:0;margin:0;color:#222;font-size:12px;font-family:Visby CF Medium;padding-top:2px}.kuFilterTagsContainer{margin-left:auto;width:86%;margin-top:10px;color:#888}.kuFilters[data-position=top] .kuFilterBox{display:inline-block;float:left;height:auto;margin-bottom:5px;margin-left:-1px;min-width:90px;position:relative;width:auto}.kuFilters[data-position=top] .kuFilterBox .kuFilterHead{border-bottom:0 none;border-right:0 solid #e8e8e8;color:#1a1717!important;height:32px;line-height:32px;padding:0 20px 0 10px;position:relative!important;text-align:center;text-transform:uppercase;margin:0;font-family:Quicksand,sans-serif!important}.kuSearchResultsPageContainer .kuDropdown .kuDropdownLabel{border:0;color:#93705a!important;padding:0;text-transform:unset;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-family:Quicksand!important}.kuSearchResultsPageContainer .kuDropdown{float:left;margin:0}.kuSearchResultsPageContainer .kuDropdown .kuDropdownLabel:after{content:unset}.ku-klevu .kuSearchResultsPageContainer .kuDropdown .kuSortingOption{display:inline;height:auto;min-height:22px;width:auto;margin-left:5px;max-width:175px;padding:13px 20px;padding-right:25px;border:1px solid #ddd;font:1em Quicksand!important;text-transform:capitalize;text-align:center;color:#1a1717!important}.kuLandingResultsViewSwitchContainer{padding:0;margin-left:auto;margin-top:10px!important;padding-top:12px}.kuResultWrap [data-block-id=ku_landing_result_header]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.kuSearchResultsPageContainer .kuResults ul{display:grid;grid-template-columns:1fr 1fr 1fr 1fr}.kuSearchResultsPageContainer .kuResults ul li{margin:8px 0 20px 0!important;padding:15px;border:1px solid transparent;border-radius:3px;width:100%!important}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap{border:0}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop{padding:0}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop .klevuImgWrap{padding-bottom:100%;height:0!important}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdBottom{height:auto;padding:0;text-align:center;margin-top:20px}.kuSearchResultsPageContainer .kuResults ul li .kuName a{font-size:14px;text-decoration:none;color:#414042;border:0;text-transform:capitalize;font-family:"Visby CF Extra Bold";font-weight:600}.kuSearchResultsPageContainer .kuResults ul li .kuDesc{font-size:12px}.kuProdBottom .kuPrice{margin-top:10px;padding-left:10px;text-align:center}.kuPrice .kuSalePrice{font-size:12px;text-align:center;display:inline;margin-right:10px;font-weight:200}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdAdditional{visibility:visible!important;opacity:1!important;-webkit-box-shadow:0!important;box-shadow:0!important;border:0;position:initial}.kuSearchResultsPageContainer .kuResults ul li:hover .kuProdAdditional{border:0;-webkit-box-shadow:unset;box-shadow:unset}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdAdditional .kuProdAdditionalData{padding:0}.kuSearchResultsPageContainer .kuAddtocart .kuBtn{background:#ff828a;color:#fff!important;border:1px solid #ff828a;padding:13px 15px;margin:20px 0 10px 0;text-align:center;vertical-align:middle;cursor:pointer;white-space:nowrap;text-decoration:none;line-height:19px;border-radius:0;text-transform:capitalize;font-family:"Visby CF Extra Bold";display:block;font-size:16px!important;font-weight:600}.kuResultInfo{border-bottom:1px solid #c7c8ca;width:100%;margin-top:28px}.kuTotResults{text-align:left;margin-bottom:10px;line-height:24px;font-weight:700;font-size:14px;float:left;color:#414042}.kuTotResults strong{font-size:14px;font-weight:600}.noUi-horizontal{height:6px}.noUi-handle:after,.noUi-handle:before{content:unset}.noUi-horizontal .noUi-handle{top:-10px}.kuFilters[data-position=top]{margin-bottom:0;-ms-flex-wrap:wrap;flex-wrap:wrap}.klevuWrap [ku-container][data-container-role=main]{max-width:1280px;display:block;margin:0 auto;width:100%;padding:0 60px}.kuResultWrap [ku-container][data-container-role=content]{display:block}.ku-klevu.template-page .main-content{padding:0!important}.kuFilters[data-position=top] .kuFilterBox .kuFilterHead,.kuFilters[data-position=top] .kuFiltersTitleHeading,.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li .klevuQuickOrigPrice,.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li .klevuQuickSalePrice,.kuSearchResultsPageContainer .kuDropdown .kuSortingOption{color:#93705a!important}@media screen and (max-width:1280px){.klevuWrap [ku-container][data-container-role=main]{padding:0 20px}}@media screen and (max-width:1024px){.kuSearchResultsPageContainer .kuResults ul{grid-template-columns:1fr 1fr 1fr}.kuFilters[data-position=top] .kuFiltersTitleHeading{font-size:13px;line-height:23px}}@media only screen and (max-width:640px){.kuSearchResultsPageContainer .kuResults ul{grid-template-columns:1fr 1fr}.kuFilters[data-position=top] .kuFiltersTitleHeading,.kuLandingResultsViewSwitchContainer{display:none!important}.kuResultInfo{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.kuSearchResultsPageContainer .kuDropdown{margin-left:auto}}@media screen and (max-width:990px){.klevuWrap.productListActive [ku-container][data-container-role=main]{margin-top:160px}}@media only screen and (max-width:1200px){.kuFilters[data-position=top] .kuFilterBox{border:1px solid #e8e8e8;margin-bottom:3px;margin-right:-1px}.kuFilters[data-position=top] .kuFilterBox .kuFilterHead.kuCollapse::after{right:10px}}.kuFilters[data-position=top] .kuFilterBox{display:none}.kuFilters[data-position=top] .kuFilterBox[data-filter="Price Range"],.kuFilters[data-position=top] .kuFilterBox[data-filter=category],.kuFilters[data-position=top] .kuFilterBox[data-filter=klevu_price],.kuFilters[data-position=top] .kuFilterBox[data-filter=type]{display:inline-block}.kuProdBottom .kuPrice{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.kuLandingResultsViewSwitchContainer{z-index:1}.kuSearchResultsPageContainer [data-result-view=list] .kuResults ul{display:block}[data-result-view=list] .klevuProduct .kuAddtocart .kuBtn{display:block;margin:0 auto;width:30%}.kuSearchResultsPageContainer [data-result-view=list] .kuResults ul li .kuProdWrap .kuProdAdditional{margin-top:30px}.kuSearchResultsPageContainer .kuDropdown .kuDropdownOptions{min-width:170px;left:65px}@media screen and (max-width:767px){[data-result-view=list] .klevuProduct .kuAddtocart .kuBtn{width:50%}}@media screen and (max-width:576px){.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop .klevuImgWrap{padding-bottom:60%}.kuSearchResultsPageContainer .kuDropdown svg{top:23px!important}.kuSearchResultsPageContainer .kuDropdown .kuDropdownOptions{min-width:150px;left:55px}}.klevuQuickSearchingArea *{letter-spacing:.06em;color:#93705a!important;font-family:HelvCondensed,sans-serif!important}.kuSearchResultsPageContainer [data-result-view=list] .kuResults ul li .kuProdWrap .kuProdTop .klevuImgWrap{padding-bottom:70%}.kuSearchResultsPageContainer [data-result-view=list] .kuSwatches{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:0 auto}.kuSearchResultsPageContainer .kuDropdown svg{width:20px;height:20px;position:absolute;top:25px;right:3px}.kuProdWrap [data-block-id=ku_landing_result_item_footer]{min-height:200px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.klevuWrap [href]:focus,.klevuWrap [tabindex]:not([tabindex="-1"]):focus,.klevuWrap a:focus,.klevuWrap button:focus{outline:2px solid #ff828a!important}`;

klevu.interactive(function () {
  klevu({
    powerUp: {
      landing: false,
      catnav: false,
      quick: false,
    }
  });
});

klevu.coreEvent.build({
  name: "setRemoteConfigQuickOverride",
  fire: function () {
    if (klevu.getSetting(klevu, "settings.flags.setRemoteConfigQuick.build", false)) {
      return true;
    }
    return false;
  },
  maxCount: 150,
  delay: 100
});

klevu.coreEvent.attach("setRemoteConfigQuickOverride", {
  name: "attachRemoteConfigQuickOverride",
  fire: function () {
    klevu.each(
      klevu.search.extraSearchBox, function (key, box) {
        box.getScope().template.setTemplate(klevuQuickTemplateBaseCustom, "klevuTemplateBase", true);
        // box.getScope().template.setTemplate(klevuQuickPageSuggestionsCustom, "klevuQuickPageSuggestions", true);
        box.getScope().template.setTemplate(klevuTrendingProductsCustom, "klevuTrendingProducts", true);
        box.getScope().template.setTemplate(klevuTemplateNoResultFoundQuickCustom, "noResultsFoundQuick", true);

        box.getScope().chains.template.process.success.addAfter("processCurrencySetting", {
          name: "updateCurrencyFormatQuick",
          fire: function (data, scope) {
            klevu.search.modules.currencySetUp(data, scope);
          }
        });
      }
    );


    klevu.dom.helpers.addElementToHead({
      name: "klevu-custom-styles",
      content: customStyleContent,
      type: "css"
    });

    klevu({
      powerUp: {
        quick: true
      }
    });
  }
});

// Landing
klevu.coreEvent.build({
  name: "setRemoteConfigLandingOverride",
  fire: function () {
    if (klevu.getSetting(klevu, "settings.flags.setRemoteConfigLanding.build") || klevu.getSetting(klevu, "settings.flags.setRemoteConfigCatnav.build")) {
      if (klevu.getSetting(klevu, "settings.flags.setRemoteConfigLanding.build")) {
        window.pageType = 'landing';
        window.setRemoteConfig = 'setRemoteConfigLanding';
      }
      if (klevu.getSetting(klevu, "settings.flags.setRemoteConfigCatnav.build")) {
        window.pageType = 'catnav';
        window.setRemoteConfig = 'setRemoteConfigCatnav';
      }
      return true;
    }
    return false;
  },
  maxCount: 150,
  delay: 100
});

klevu.coreEvent.attach("setRemoteConfigLandingOverride", {
  name: "attachRemoteConfigLandingOverride",
  fire: function () {
    document.getElementsByTagName('body')[0].classList.add('ku-klevu');

    try {
      klevu.search[window.pageType].getScope().chains.request.control.addAfter("initRequest", {
        name: "setInitItemPerPage",
        fire: function (data, scope) {
          klevu.each(data.request.current.recordQueries, function (key, query) {
            query.filters.filtersToReturn.options.limit = 200;
          }
          );
        },
      });
    } catch (error) {
      console.log(error);
    }

    // TEMPLATES:
    klevu.search[window.pageType].getScope().template.setTemplate(klevuLandingTemplateResultsCustom, "results", true);
    // klevu.search[window.pageType].getScope().template.setTemplate(klevuLandingTemplateTabResultsCustom, "tab-results", true);
    klevu.search[window.pageType].getScope().template.setTemplate(kuFilterTagsTemplateCustom, "kuFilterTagsTemplate", true);
    klevu.search[window.pageType].getScope().template.setTemplate(klevuLandingTemplateTopFiltersCustom, "filtersTop", true);
    klevu.search[window.pageType].getScope().template.setTemplate(landingPageProductAddToCartCustom, "landingPageProductAddToCart", true);
    // klevu.search[window.pageType].getScope().template.setTemplate(klevuLandingTemplateInfiniteScrollDownCustom, "klevuLandingTemplateInfiniteScrollDown", true);
    klevu.search[window.pageType].getScope().template.setTemplate(klevuLandingTemplateSortByCustom, "sortBy", true);


    // try {
    //   klevu.search[window.pageType].getScope().template.setHelper("isScreenWidthSmaller", function isScreenWidthSmaller(screenWidth){
    //     if (!screenWidth) screenWidth = 800;
    //     var widthOfScreen = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    //     return widthOfScreen <= screenWidth;
    //   });
    // } catch (error) {
    //   console.log(error)
    // }

    klevu.search[window.pageType].getScope().chains.events.keyUp.remove({
      name: "scrollToTop"
    });

    klevu.search[window.pageType].getScope().chains.template.process.success.addAfter("processCurrencySetting", {
      name: "updateCurrencyFormat",
      fire: function (data, scope) {
        klevu.search.modules.currencySetUp(data, scope);
      }
    });

    klevu.coreEvent.attach("setRemoteConfigLanding", {
      name: "attachInfiniteScrollOnWindow",
      fire: function () {

        var hasInfiniteScrollEnabled = klevu.getGlobalSetting("theme.modules.resultInfiniteScroll.searchResultsPage.enable", false);
        if (hasInfiniteScrollEnabled === false) {
          return;
        }

        klevu.search.landing.getScope().chains.template.events.add({
          name: "hideLoadMoreButtonForWindowScroll",
          fire: function (data, scope) {
            var target = klevu.getSetting(scope.kScope.settings, "settings.search.searchBoxTarget");

            // var kuLoadMoreBtn = klevu.dom.find(".kuLoadMoreBtn", target);
            // if (kuLoadMoreBtn.length) {
            // klevu.each(kuLoadMoreBtn, function (key, element) {
            //     element.classList.add("hide");
            // });
            // }
          }
        });
      }
    });

    try {
      klevu.search[window.pageType].getScope().chains.template.events.add({
        name: "filterOpener",
        fire: function (data, scope) {
          if (document.querySelector('.kuFilterBox[data-filter="category"]')) {
            if (!document.querySelector('.kuFilterBox[data-filter="category"] .kuFilterNames ul li')) {
              document.querySelector('.kuFilterBox[data-filter="category"]').style = 'display:none';
            }
          }
        }
      });
    } catch (error) {
      console.log(error)
    }

    klevu.search[window.pageType].getScope().template.setHelper("getSortByCustom", function (name) {
      var landingStorage = klevu.getGlobalSetting("storage");
      var sorting = (landingStorage.sort.getElement(name) == name) ? "Best Selling" : landingStorage.sort.getElement(name);
      var returnedValue = "";
      switch (sorting) {
        case "RELEVANCE":
          returnedValue = 'Best Selling';
          break;
        case "NAME_ASC":
          returnedValue = 'Alphabetically, A-Z';
          break;
        case "NAME_DESC":
          returnedValue = 'Alphabetically, Z-A';
          break;
        case "PRICE_ASC":
          returnedValue = 'Price: Low to high';
          break;
        case "PRICE_DESC":
          returnedValue = 'Price: High to low';
          break;
        default:
          returnedValue = 'Best Selling';
          break;
      }
      return returnedValue;
    });

    if (window.pageType === 'landing') { klevu({ powerUp: { landing: true } }) }
    if (window.pageType === 'catnav') { klevu({ powerUp: { catnav: true } }) }

  }
});

(function (klevu) {
  klevu.extend(true, klevu.search.modules, {
    currencySetUp: function (data, scope) {
      scope.kScope.currency.setCurrencys({
        'USD': {
          string: "$",
          format: "%s%s",
          atEnd: false,
          precision: 2,
          thousands: ",",
          decimal: ".",
          grouping: 3
        }
      });
      scope.kScope.currency.mergeToGlobal();
    },
  });
})(klevu);

(function (klevu) {
  klevu.extend({
    productCarousel: {
      base: {
        initProductsSlider: function (kuCarousel) {
          if (!kuCarousel) {
            return;
          }
          var kuCarouselContent = kuCarousel.querySelector('.kuCarousel-content');
          if (!kuCarouselContent) {
            return;
          }
          var slides = kuCarousel.querySelectorAll('.kuSlide');
          if (!slides) {
            return;
          }

          var arrayOfSlides = Array.prototype.slice.call(slides);
          var kuCarouselDisplaying;
          var screenSize;
          var lengthOfSlide;

          function addClone() {
            var lastSlide = kuCarouselContent.lastElementChild.cloneNode(true);
            lastSlide.style.left = (-lengthOfSlide) + "px";
            kuCarouselContent.insertBefore(lastSlide, kuCarouselContent.firstChild);
          }

          function removeClone() {
            var firstSlide = kuCarouselContent.firstElementChild;
            firstSlide.parentNode.removeChild(firstSlide);
          }

          function moveSlidesRight() {
            var slides = kuCarousel.querySelectorAll('.kuSlide');
            var slidesArray = Array.prototype.slice.call(slides);
            var width = 0;

            slidesArray.forEach(function (el, i) {
              el.style.left = width + "px";
              width += lengthOfSlide;
            });
            addClone();
          }

          moveSlidesRight();

          function moveSlidesLeft() {
            var slides = kuCarousel.querySelectorAll('.kuSlide');
            var slidesArray = Array.prototype.slice.call(slides);
            slidesArray = slidesArray.reverse();
            var maxWidth = (slidesArray.length - 1) * lengthOfSlide;
            slidesArray.forEach(function (el, i) {
              maxWidth -= lengthOfSlide;
              el.style.left = maxWidth + "px";
            });
          }

          window.addEventListener('resize', setScreenSize);

          function setScreenSize() {
            if (window.innerWidth >= 1025) {
              kuCarouselDisplaying = 5;
            } else if (window.innerWidth >= 641) {
              kuCarouselDisplaying = 3;
            } else {
              kuCarouselDisplaying = 2;
            }
            getScreenSize();
          }

          function getScreenSize() {
            var slides = kuCarousel.querySelectorAll('.kuSlide');
            var slidesArray = Array.prototype.slice.call(slides);
            lengthOfSlide = (kuCarousel.offsetWidth / kuCarouselDisplaying);
            var initialWidth = -lengthOfSlide;
            slidesArray.forEach(function (el) {
              el.style.width = lengthOfSlide + "px";
              el.style.left = initialWidth + "px";
              initialWidth += lengthOfSlide;
            });
          }

          var rightNav = kuCarousel.querySelector('.nav-right');
          rightNav.addEventListener('click', moveLeft);

          var moving = true;

          function moveRight() {
            if (moving) {
              var slides = kuCarousel.querySelectorAll('.kuSlide');
              var totalSlidesLength = slides.length - 1;
              if (parseInt(slides[0].id) >= totalSlidesLength) {
                return;
              }
              moving = false;
              var lastSlide = kuCarouselContent.lastElementChild;
              lastSlide.parentNode.removeChild(lastSlide);
              kuCarouselContent.insertBefore(lastSlide, kuCarouselContent.firstChild);
              removeClone();
              var firstSlide = kuCarouselContent.firstElementChild;
              firstSlide.addEventListener('transitionend', activateAgain);
              moveSlidesRight();
            }
          }

          function activateAgain() {
            var firstSlide = kuCarouselContent.firstElementChild;
            moving = true;
            firstSlide.removeEventListener('transitionend', activateAgain);
          }

          var leftNav = kuCarousel.querySelector('.nav-left');
          leftNav.addEventListener('click', moveRight);

          function moveLeft() {
            if (moving) {
              var slides = kuCarousel.querySelectorAll('.kuSlide');
              var totalSlidesLength = slides.length - 1;
              if (parseInt(slides[1].id) + kuCarouselDisplaying > totalSlidesLength) {
                return;
              }
              moving = false;
              removeClone();
              var firstSlide = kuCarouselContent.firstElementChild;
              firstSlide.addEventListener('transitionend', replaceToEnd);
              moveSlidesLeft();
            }
          }

          function replaceToEnd() {
            var firstSlide = kuCarouselContent.firstElementChild;
            firstSlide.parentNode.removeChild(firstSlide);
            kuCarouselContent.appendChild(firstSlide);
            firstSlide.style.left = ((arrayOfSlides.length - 1) * lengthOfSlide) + "px";
            addClone();
            moving = true;
            firstSlide.removeEventListener('transitionend', replaceToEnd);
          }

          kuCarouselContent.addEventListener('mousedown', seeMovement);

          var initialX;
          var initialPos;

          function seeMovement(e) {
            initialX = e.clientX;
            getInitialPos();
            kuCarouselContent.addEventListener('mousemove', slightMove);
            kuCarousel.addEventListener('mouseup', moveBasedOnMouse);
          }

          function slightMove(e) {
            if (moving) {
              var movingX = e.clientX;
              var difference = initialX - movingX;
              if (Math.abs(difference) < (lengthOfSlide / 4)) {
                slightMoveSlides(difference);
              }
            }
          }

          function getInitialPos() {
            var slides = kuCarousel.querySelectorAll('.kuSlide');
            var slidesArray = Array.prototype.slice.call(slides);
            initialPos = [];
            slidesArray.forEach(function (el) {
              var left = Math.floor(parseInt(el.style.left.slice(0, -2)));
              initialPos.push(left);
            });
          }

          function slightMoveSlides(newX) {
            var slides = kuCarousel.querySelectorAll('.kuSlide');
            var slidesArray = Array.prototype.slice.call(slides);
            slidesArray.forEach(function (el, i) {
              var oldLeft = initialPos[i];
              el.style.left = (oldLeft + newX) + "px";
            });
          }

          function moveBasedOnMouse(e) {
            var finalX = e.clientX;
            if (initialX - finalX > 0) {
              moveRight();
            } else if (initialX - finalX < 0) {
              moveLeft();
            }
            kuCarousel.removeEventListener('mouseup', moveBasedOnMouse);
            kuCarouselContent.removeEventListener('mousemove', slightMove);
          }

          setScreenSize();
        }
      }
    }
  });
})(klevu);
const klevuLandingTemplateResultsCustom = `
<div class="kuResultsListing">
        <div class="productList klevuMeta" data-section="productList">
            <div class="kuResultContent">
                <div class="kuResultWrap <%=(data.query.productList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                    <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                        <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                            <div ku-block data-block-id="ku_landing_left_facets">                                
                                <%=helper.render('filters',scope,data,"productList") %>
                            </div>
                            <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_left_banner"></div>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                            
                            <header ku-block data-block-id="ku_landing_result_header">
                                <%=helper.render('klevuLandingTemplateResultsHeadingTitle',scope,data,"productList") %>
                                <%=helper.render('filtersTop',scope,data,"productList") %>
                                <%= helper.render('kuFilterTagsTemplate',scope,data,"productList") %>
                                <% var searchTerm = (typeof data.settings !== 'undefined' && typeof data.settings.term !== 'undefined') ? data.settings.term : '' %>
                                <div class="kuResultInfo">
                                    <div class="kuTotResults" id="kuTotResults"><strong> <%=data.query.productList.meta.totalResultsFound %></strong> Result(s) found for '<%=searchTerm%>'</div>
                                </div>
                                <% if(helper.hasResults(data,"productList")) { %>
                                    <%=helper.render('sortBy',scope,data,"productList") %>
                                    <%=helper.render('limit',scope,data,"productList") %>
                                    <%=helper.render('kuTemplateLandingResultsViewSwitch',scope,data,"productList") %>
                                    <%=helper.render('pagination',scope,data,"productList") %>
                                <% } %>
                                <div class="kuClearBoth"></div>
                            </header>

                            <div ku-block data-block-id="ku_landing_result_items">
                                <div class="kuResults">
                                    <% if(helper.hasResults(data,"productList")) { %>
                                        <ul>
                                            <% helper.each(data.query.productList.result,function(key,item){ %>
                                                <% if(item.typeOfRecord == "KLEVU_PRODUCT") { %>
                                                    <%=helper.render('productBlock',scope,data,item) %>
                                                <% } %>
                                            <% }); %>
                                        </ul>
                                    <% } else { %>
                                        <div class="kuNoRecordsFoundLabelTextContainer">
                                            <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                        </div>
                                    <% } %>
                                    <div class="kuClearBoth"></div>
                                </div>
                            </div>
                            
                            <div ku-block data-block-id="ku_landing_other_items">
                                <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>                               
                            </div>
                            <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                            <div ku-block data-block-id="ku_landing_right_facets"></div>
                            <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_right_banner"></div>
                        </section>
                    </div>
                    
                </div>
            </div>
        </div>

        <% if(data.query.contentList) { %>
            <div class="contentList klevuMeta" data-section="contentList" data-result-view="list">
                <div class="kuResultContent">
                    <div class="kuResultWrap <%=(data.query.contentList.filters.length == 0 )?'kuBlockFullwidth':''%>">
    
                        <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                            <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                                <div ku-block data-block-id="ku_landing_left_facets">
                                    
                                    <%=helper.render('filters',scope,data,"contentList") %>
    
                                </div>
                                <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                                <div ku-block data-block-id="ku_landing_left_banner"></div>
                            </section>
                            <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                                
                                <header ku-block data-block-id="ku_landing_result_header">
                                    <%=helper.render('filtersTop',scope,data,"contentList") %>
                                    <%= helper.render('kuFilterTagsTemplate',scope,data,"contentList") %>
                                    <% if(helper.hasResults(data,"contentList")) { %>
                                        <%=helper.render('limit',scope,data,"contentList") %>
                                        <%=helper.render('pagination',scope,data,"contentList") %>
                                    <% } %>
                                    <div class="kuClearBoth"></div> 
                                </header>

                                <div ku-block data-block-id="ku_landing_result_items">
                                    <div class="kuClearBoth"></div>
                                    <div class="kuResults">
                                        <% if(helper.hasResults(data,"contentList")) { %>
                                            <ul>
                                                <% helper.each(data.query.contentList.result,function(key,item){ %>
                                                    <% if(item.typeOfRecord == "KLEVU_CMS") { %>
                                                        <%=helper.render('contentBlock',scope,data,item) %>
                                                    <% }%>
                                                <% }); %>
                                            </ul>
                                        <% } else { %>
                                            <div class="kuNoRecordsFoundLabelTextContainer">
                                                <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                            </div>
                                        <% } %>
                                        <div class="kuClearBoth"></div>
                                    </div>
                                </div>
                                <div ku-block data-block-id="ku_landing_other_items">
                                    <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>
                                </div>
                                <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                            </section>
                            <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                                <div ku-block data-block-id="ku_landing_right_facets"></div>
                                <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                                <div ku-block data-block-id="ku_landing_right_banner"></div>
                            </section>
                        </div>
                        
                    </div>
                </div>
            </div>
        <% } %> 

    </div>
`;
const klevuLandingTemplateSortByCustom = `
<div class="kuDropdown kuDropSortBy" role="listbox">
<div class="kuDropdownLabel"><%=helper.translate("Sort by : ")%> <span class="kuSortingOption"><%=helper.translate(helper.getSortByCustom(dataLocal))%></span></div>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M14 20l10 10 10-10z"/><path d="M0 0h48v48h-48z" fill="none"/></svg>
<div class="kuDropdownOptions">
    <div class="kuDropOption kuSort" data-value="RELEVANCE" role="option"><%=helper.translate("Best Selling")%></div>
    <div class="kuDropOption kuSort" data-value="NAME_ASC" role="option"><%=helper.translate("Alphabetically, A-Z")%></div>
    <div class="kuDropOption kuSort" data-value="NAME_DESC" role="option"><%=helper.translate("Alphabetically, Z-A")%></div>
    <div class="kuDropOption kuSort" data-value="PRICE_ASC" role="option"><%=helper.translate("Price: Low to high")%></div>
    <div class="kuDropOption kuSort" data-value="PRICE_DESC" role="option"><%=helper.translate("Price: High to low")%></div>
</div>
</div>
`;
const klevuLandingTemplateTopFiltersCustom = `
<% if(data.query[dataLocal].filters.length > 0 ) { %>
    <div class="kuFilters kuFiltersTop" role="navigation" data-position="top" aria-label="Product Filters" tabindex="0">
        <h3 class="kuFiltersTitleHeading"><%=helper.translate("Narrow by")%></h3>
        <% helper.each(data.query[dataLocal].filters,function(key,filter){ %>
            <% if(filter.type == "OPTIONS"){ %>
                <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                        <%=helper.translate(filter_label)%>
                    </div>
                    <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length < 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                        <ul>
                            <% helper.each(filter.options,function(key,filterOption){ %>
                                <% if (filter.key == 'category') { %>  
                                    <% if (filterOption.value.toLowerCase() == 'skintreats' ||
                                        filterOption.value.toLowerCase() == 'makeup' ||
                                        filterOption.value.toLowerCase() == 'pixi+ hello kitty' ||
                                        filterOption.value.toLowerCase() == 'pretties' ||
                                        filterOption.value.toLowerCase() == 'colroutreats' ||
                                        filterOption.value.toLowerCase() == 'bodytreats') { %>
                                            <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                                <a 
                                                    target="_self" 
                                                    href="#" 
                                                    title="<%=helper.escapeHTML(filterOption.name)%>" 
                                                    class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                                    data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                                    data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                                >
                                                    <span class="kuFilterIcon"></span>
                                                    <span class="kufacet-text"><%=filterOption.name%></span>
                                                    <span class="kuFilterTotal"><%=filterOption.count%></span>
                                                </a>
                                            </li>
                                    <% } %>
                                <% } else { %>
                                    <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                        <a 
                                            target="_self" 
                                            href="#" 
                                            title="<%=helper.escapeHTML(filterOption.name)%>" 
                                            class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                            data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                            data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                        >
                                            <span class="kuFilterIcon"></span>
                                            <span class="kufacet-text"><%=filterOption.name%></span>
                                            <span class="kuFilterTotal"><%=filterOption.count%></span>
                                        </a>
                                    </li>
                                <% } %>
                            <%  }); %>
                        </ul>
                        <% if(filter.options.length > 5 ) { %>
                            <div class="kuShowOpt" tabindex="-1">
                                <span class="kuFilterDot"></span><span class="kuFilterDot"></span><span class="kuFilterDot"></span>
                            </div>
                        <% } %>
                    </div>
                </div>
            <% } else if(filter.type == "SLIDER")  { %>
                <div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>">
                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                        <%=helper.translate(filter_label)%>
                    </div>
                    <div class="kuFilterNames sliderFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">                           
                          <div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>">
                              <div data-querykey = "<%=dataLocal%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div>
                          </div>
                    </div>
                </div>
            <% } else if(filter.type == "RATING")  { %>
                <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        <%=helper.translate(filter.label)%>
                    </div>
                    <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length < 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                        <ul>
                            <% helper.each(filter.options,function(key,filterOption){ %>
                                <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                    <a 
                                        target="_self" 
                                        href="#" 
                                        title="<%=helper.escapeHTML(filterOption.name)%>" 
                                        class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                        data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                        data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                    >
                                        <span class="kuFilterIcon"></span>
                                        <span class="kufacet-text">
                                            <div class="klevuFacetStars">
                                                <div class="klevuFacetRating" style="width:<%=(20*Number(filterOption.name))%>%;"></div>
                                            </div>
                                        </span>
                                        <span class="kuFilterTotal"><%=filterOption.count%></span>
                                    </a>
                                </li>
                                
                            <%  }); %>
                        </ul>
                    </div>
                </div>
            <% } else { %>
                <!-- Other Facets -->
            <% } %>
        <% }); %>
        
        <!-- <div class="kuFiltersFooter">
            <a target="_self" href="javascript:void(0)" class="kuBtn kuFacetsSlideOut kuMobileFilterCloseBtn" role="button" tabindex="0" area-label=""><%=helper.translate("Close")%></a>
          </div> -->
          
    </div>
<% } %>
`;
const klevuQuickTemplateBaseCustom = `
<div class="klevu-fluid kuPreventDocumentClick">
<div id="klevuSearchingArea" class="klevuQuickSearchingArea">
    <div ku-container data-container-id="ku_quick_main_container" data-container-role="main">
    <%console.log(data.query.productList)%>
    <% if(data.query.productList && data.query.productList.result.length !== 0) { %>
        <header ku-container data-container-id="ku_quick_main_header_container" data-container-role="header">
            <section ku-block data-block-id="ku_quick_main_header_sub_panel"></section>
            <section ku-block data-block-id="ku_quick_main_header_banner">
                <%=helper.render('klevuQuickPromotionBanner',scope,data,"top") %>                    
            </section>
            <section ku-block data-block-id="ku_quick_main_header_site_navigation">
                <div class="klevuSuggestionsBlock">                            
                    <%=helper.render('klevuQuickAutoSuggestions',scope) %>
                    <%=helper.render('klevuQuickPageSuggestions',scope) %>
                    <%=helper.render('klevuQuickCategorySuggestions',scope) %>
                </div>
            </section>
        </header>
    <% } %>
        <% if(data.showQuickFacetedLayoutCharLimitMessage == true) { %>
            <% var quickFacetedLayoutMessage = (data.quickFacetedLayoutMinCharsTextValue) ? data.quickFacetedLayoutMinCharsTextValue : ""; %>
            <% if(quickFacetedLayoutMessage != "") { %>
                <span class="kuFacetedLayoutMinCharText"><%= helper.translate(quickFacetedLayoutMessage) %></span>
            <% } %>                    
        <% } else { %>
            <% if(data.query.productList) { %>
                <%=helper.render('klevuQuickTemplateResultsHeadingTitle',scope,data,"productList") %>
                <%= helper.render('klevuQuickTemplateTabResults',scope) %>                                                 
                <%= helper.render('klevuQuickProducts',scope) %>
                <%= helper.render('klevuQuickOtherContent',scope) %>
            <% } else { %>              
                <div class="kuSearchPersonalizationsContainer">
                    <%= helper.render('klevuSearchPersonalizations',scope) %>    
                </div>
            <% } %>  
        <% } %>
    
        <footer ku-container data-container-id="ku_quick_main_footer_container" data-container-role="footer">
            <section ku-block data-block-id="ku_quick_main_footer_sub_panel"></section>
            <section ku-block data-block-id="ku_quick_main_footer_banner">
                <%=helper.render('klevuQuickPromotionBanner',scope,data,"bottom") %>
            </section>
        </footer> 
    </div>
</div>
</div>
`;
const klevuTemplateNoResultFoundQuickCustom = `
<div class="kuQuickSearchNoRecordFound">
        <div class="kuQuickNoResults">
            <div class="kuQuickNoResultsInner">
                <div class="kuQuickNoResultsMessage">
                    <%= helper.translate('Please, try another search term...') %>
                </div>                
            </div>
        </div>
        <div class="kuDividerLine"></div>
        <%=helper.render('quickNoResultsPopularProducts', scope, data) %>
        <%=helper.render('quickNoResultsFoundBanners', scope, data) %>
        <%=helper.render('quickNoResultsPopularSearches', scope, data) %>
    </div>
`;
const klevuTrendingProductsCustom = `
<% 
        var trendingProductsTitle = klevu.getObjectPath(data,"modules.trendingProducts.title"); 
        trendingProductsTitle = (trendingProductsTitle) ? trendingProductsTitle : "";
    %>
    <% if(data.query.trendingProductList) { %>
        <% if(data.query.trendingProductList.result.length > 0 ) { %>
            <div class="klevuResultsBlock kuPreventDocumentClick kuRecommendationSlider">
                <div class="klevuSuggestionHeading">
                    <span class="klevuHeadingText"><%= helper.translate(trendingProductsTitle) %></span>
                </div>
                <div class="klevuQuickSearchResults klevuQuickSearchTrendingResults" data-section="trendingProductList" data-source="trendingProducts" id="trendingProductList">
                    <div class="kuCarousel kuTrendingProductsCarousel">
                        <button role="button" tabindex="0" class="nav nav-left">
                            <div class="ion-chevron-left kuCarousel-arrow-icon-left"></div>
                        </button>
                        <div class="kuCarousel-content">
                            <% helper.each(data.query.trendingProductList.result,function(key,product){ %>
                                <div class="klevuProduct kuQSMenuItem kuSlide" id="<%= (key + 1) %>" ku-product-block
                                    data-id="<%=product.id%>">
                                    <%=helper.render('klevuQuickTrendingProductBlock',scope,data,product) %>
                                </div>
                            <% }); %>
                        </div>
                        <button role="button" tabindex="0" class="nav nav-right">
                            <div class="ion-chevron-right kuCarousel-arrow-icon-right"></div>
                        </button>
                    </div>
                </div>
            </div>
        <% } %>
    <% } %>
`;
const kuFilterTagsTemplateCustom = `
<% 
        var filterTagsModule = data.filterTags;
        var filterTagsData = [];
        if(dataLocal && dataLocal.length){
            filterTagsData = filterTagsModule.query[dataLocal].tags;
        }
    %>
    <% if(filterTagsData.length) { %>
        <div class="kuFilterTagsContainer">        
            <% helper.each(filterTagsData, function(key,item){ 
                var filterTagItemKey = helper.escapeHTML(item.key);
                var filterTagItemLabel = helper.escapeHTML(helper.translate(item.label));
                %>
                <span 
                    class="kuFilterTag" 
                    data-key="<%= filterTagItemKey %>"
                    data-type="<%= helper.escapeHTML(item.type) %>"
                >
                    <span 
                        title="<%= filterTagItemLabel %>" 
                        data-value="<%= filterTagItemLabel %>" 
                        class="kuFilterTagKey"
                    >
                        <%= helper.translate(item.label) %> :
                    
                    <% helper.each(item.values, function(key,option){ %>
                        </span>
                        <% if(item.type === "RATING") { %>
                            <span 
                                title="<%= helper.escapeHTML(helper.translate(option)) %>" 
                                data-value="<%= helper.escapeHTML(helper.translate(option)) %>"
                                class="kuFilterTagValue">
                                <div class="klevuFacetStars">
                                    <div class="klevuFacetRating" style="width:<%=(20*Number(option))%>%;"></div>
                                </div>
                                <span>&times;</span>
                            </span>
                        <% } else { %>
                            <span 
                                title="<%= helper.escapeHTML(helper.translate(option)) %>" 
                                data-value="<%= helper.escapeHTML(helper.translate(option)) %>"
                                class="kuFilterTagValue">
                                <%= helper.translate(option) %>
                                <span>&times;</span>
                            </span>
                        <% } %>
                    <% }); %>
                </span>
            <% }); %>
            <span title="<%= helper.translate("Clear all") %>" class="kuFilterTagClearAll"><%= helper.translate("Clear all") %></span>
        </div>
    <% } %>
`;
const landingPageProductAddToCartCustom = `
<% if(dataLocal.inStock != "no") { %>
    <% var addToCartCaption = klevu.search.modules.kmcInputs.base.getAddToCartButtonCaption(); %>

    <% 
    var hasMultipleOptions = false;
    try {
        var fixedJson = dataLocal.Simple_Bundles
            .replace(/"optionName" "/g, '"optionName": "')
            .replace(/"optionValues" "/g, '"optionValues": "')
            .replace(/"defaultOptionName" "/g, '"defaultOptionName": "')
            .replace(/"optionInventories" "/g, '"optionInventories": "');

        var bundles = JSON.parse(fixedJson);
        
        if (Array.isArray(bundles)) {
            hasMultipleOptions = bundles.some(bundle => 
                bundle.optionValues && bundle.optionValues.includes(',')
            );
        }
    } catch(e) {
        console.error("Error processing Simple_Bundles", e);
    }
    %>

    <% if (hasMultipleOptions) { %>
        <div class="kuAddtocart" data-id="<%=dataLocal.id%>">
            <a target="_self" href="<%=dataLocal.url%>" class="kuBtn kuBtnDark" role="button" tabindex="0" area-label="View"><%=helper.translate('View') %></a>       
        </div>
    <% } else if(addToCartCaption && addToCartCaption.indexOf("<img") !== -1) { %>
        <div class="kuAddtocart" data-id="<%=dataLocal.id%>">
            <a target="_self" href="javascript:void(0)" class="kuBtn  kuLandingAddToCartBtn" role="button" tabindex="0" area-label="Add to bag">ADD TO BAG</a>
        </div>
    <% } else { %>
        <div class="kuAddtocart" data-id="<%=dataLocal.id%>">
            <a target="_self" href="javascript:void(0)" class="kuBtn kuBtnDark kuLandingAddToCartBtn" role="button" tabindex="0" area-label="Add to bag"><%=helper.translate('ADD TO BAG') %></a>       
        </div>
    <% } %>
<% } %>
`;
